<template>
    <div>
        <div class="row infoBox">
            <div class="col-sm-12 pt-0 pb-12">
                <div class="d-flex justify-end">
<!--                    <div class="filters-controls filters-controls&#45;&#45;open">-->
<!--                        <p>{{ $t('filter') }}</p>-->
<!--                        <button type="button" class="btn btn-default button button&#45;&#45;accent button&#45;&#45;filter-open" id="filter-button">-->
<!--                            <i class="glyphicon glyphicon-filter"></i>-->
<!--                        </button>-->
<!--                        &lt;!&ndash;                    <button type="button" class="btn btn-default button button&#45;&#45;hollow" id="filterReset" style="display: inline-block;">Clear</button>&ndash;&gt;-->
<!--                    </div>-->
                    <app-search-form :placeholder="$t('search_history')" @reset="reset"></app-search-form>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 pt-12 pb-12">
                <div class="history-table">
                    <div class="history-table__thead">
                        <div class="history-table__th">{{ $t('date_and_time') }}</div>
                        <div class="history-table__th">{{ $t('id_payment') }}</div>
                        <div class="history-table__th">{{ $t('summ') }}</div>
                        <div class="history-table__th">{{ $t('payment_for') }}</div>
                        <div class="history-table__th">{{ $t('total') }}</div>
                    </div>
                    <vue-custom-scrollbar class="scroll-area calcHeight scroll-area--mb"
                                          :settings="settingsHorizontal"
                    >
                        <div class="history-table__tbody">
                            <div
                                v-for="payment of payments"
                                :key="payment.id"
                                class="history-table__tr"
                            >
                                <div class="history-table__td">{{ formatDate(payment.payment_date) }}</div>
                                <div class="history-table__td">{{ payment.payment_id }}</div>
                                <div class="history-table__td">
                                    <p
                                        v-for="paymentPos of payment.payment_pos"
                                        :key="paymentPos.id"
                                    >
                                        {{ paymentPos.sum + ' грн' }}
                                    </p>
                                </div>
                                <div class="history-table__td">
                                    <p
                                        v-for="paymentPos of payment.payment_pos"
                                        :key="paymentPos.id"
                                    >
                                        {{
                                            (function() {
                                                const str = paymentPos.subscription.packages.map((item) => item.package.name);
                                                return str.join(', ');
                                            })() || '--'
                                        }}
                                    </p>
                                </div>
                                <div class="history-table__td">
                                    <strong>{{ payment.sum + ' грн' }}</strong>
                                </div>
                            </div>
                            <div v-if="payments.length === 0" class="text-center nothing_found">
                                <p style="font-weight:normal">{{ $t('nothing_found') }}</p>
                            </div>
                        </div>
                    </vue-custom-scrollbar>
                </div>
                <div class="d-flex justify-end align-center pagination-cust infoBox">
                    <div class="mr-auto" v-if="payments_payer && payments_payer.count > 5">
                        {{ $t('pagination_show_count.show') }} {{ start + 1 }} - {{ end }} {{ $t('pagination_show_count.rows') }} {{ payments_payer.count }}
                    </div>
                    <app-pagination
                            v-if="payments_payer && payments_payer.count > 5"
                            :prevText="'<'"
                            :nextText="'>'"
                            :nextPage="payments_payer && payments_payer.next"
                            :prevPage="payments_payer && payments_payer.previous"
                            type="payment_items"
                            @changePagePaymentItems="changePagePaymentItems($event)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import SearchForm from "../../courses/components/SearchForm";
    import CoursePagination from "../../common_components/CoursePagination";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import moment from "moment";

    export default {
        data: () => ({
            settingsHorizontal: {
            maxScrollbarLength: 60,
                swipeEasing: true,
                suppressScrollY: false
            },
        }),
        components: {
            appSearchForm: SearchForm,
            appPagination: CoursePagination,
            vueCustomScrollbar: vueCustomScrollbar,
        },
        computed: {
            ...mapGetters([
                'search_value',
                'students_payer',
                'payments_payer'
            ]),
            payments() {
                return this.payments_payer && this.payments_payer.results ? this.payments_payer.results : false
            },
            start () {
                let start = null;
                let searchParams = (new URL(document.location)).searchParams;

                if (this.page !== searchParams.get('page')) {
                    this.page = searchParams.get('page');
                }

                if (this.current_document_payer) {
                    start = this.page >= 1 ? (this.page * this.selectedRow) - this.selectedRow : this.page * this.selectedRow;
                }
                return start
            },
            end () {
                let result = this.payments_payer.count ? +this.payments_payer.count : 0;
                let end = +this.start + 5;
                return result < end ? result : end;
            }
        },
        methods: {
            reset(){
                this.getPaymentsData();
            },
            formatDate(date) {
                return moment(date).format('YYYY-MM-DD HH:mm')
            },
            changePagePaymentItems(event) {
                this.page = event.page;
                this.$store.dispatch('GET_PAYMENTS_PAYER', {
                    id: this.$route.params.child_id,
                    page: event.page,
                    q: this.search_value
                })
            },
            pushToUrl(val, param) {
                let url = new URL(window.location);
                if (url.searchParams.get(param) === null) {
                    url.searchParams.append(param, val)
                } else {
                    url.searchParams.set(param, val)
                }
                if (val === '') {
                    url.searchParams.delete(param)
                }
                window.history.pushState({path: url.href}, '', url.href);
            },
            getPaymentsData(){
                let searchParams = (new URL(document.location)).searchParams;
                let data ={
                    id: this.$route.params.child_id,
                    page: 1
                };
                if (searchParams.has('q')) {
                    data.q = searchParams.get('q');
                    this.$store.commit('SET_SEARCH_VALUE', searchParams.get('q'))
                }
                this.$store.dispatch('GET_PAYMENTS_PAYER', data);
            }
        },
        created() {
            this.getPaymentsData();
        },
        watch: {
            students_payer() {
                this.calcHeight();
            },
            search_value: {
                handler(val) {
                    this.pushToUrl(val, 'q');
                    this.pushToUrl(1, 'page');
                },
                deep: true
            }
        },
        beforeDestroy() {
            this.$store.commit('SET_SEARCH_VALUE', '');
        }
    }
</script>

<style scoped lang="sass">
    @import "../../../sass/variables"
    @import '../../../sass/payerCommon'

    .justify-end
        justify-content: flex-end

    .mr-auto
        margin-right: auto

    .align-center
        align-items: center

    .history-table
        width: 100%
        border: 1px solid $gray-f

        &__thead,
        &__tbody
            display: flex

        &__tbody
            flex-wrap: wrap

        &__th
            border-bottom: 1px solid $gray-f

        &__th,
        &__td
            &:nth-child(1)
                width: 15%
                min-width: 15%
                max-width: 15%
            &:nth-child(2)
                width: 20%
                min-width: 20%
                max-width: 20%
            &:nth-child(3)
                width: 25%
                min-width: 25%
                max-width: 25%
            &:nth-child(4)
                width: 20%
                min-width: 20%
                max-width: 20%
            &:nth-child(5)
                width: 20%
                min-width: 20%
                max-width: 20%

        &__th
            padding: 10px 20px
            font-weight: bold
            font-size: 14px
            color: $black-j
            border-right: 1px solid $gray-f
            background-color: $gray

            &:last-child
                text-align: center
                border-right: 0

        &__tr
            display: flex
            flex-wrap: wrap
            flex: 0 0 100%

            &:first-child .history-table__td
                border-top: 0

        &__td
            padding: 25px 20px
            border-top: 1px solid $gray-f
            border-right: 1px solid $gray-f
            font-size: 14px
            color: $black-j

            &:last-child
                font-weight: bold
                text-align: center

            p
                margin-bottom: 12px

                &:last-child
                    margin-bottom: 0

    .scroll-area table,
    .scroll-area table tr:first-child td
        border-top: 0

    .filters-controls
        margin: 0 20px 0 0
        display: flex
        align-items: center

        p
            margin: 0 10px 0 0

    .button.button--filter-open
        padding: 2px 0
        width: 30px
        height: 28px

        i
            font-size: 15px

    .nothing_found
        margin: 10px
        font-size: 14px


</style>
